import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VRow,[_c(VCol,{attrs:{"cols":"12"}},[_c('div',{staticClass:"inset-fade-effect",attrs:{"dark":_vm.$vuetify.theme.dark}}),_c('EcsThemeShowcase')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }